var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.6A9.6 9.6 0 1 0 10 .4a9.6 9.6 0 0 0 0 19.2ZM8.45 6.75a1.2 1.2 0 0 0-1.697 1.697L8.303 10 6.752 11.55a1.2 1.2 0 1 0 1.697 1.697L10 11.697l1.552 1.551a1.2 1.2 0 1 0 1.697-1.697L11.697 10l1.552-1.552a1.2 1.2 0 0 0-1.697-1.697L10 8.303 8.45 6.75Z",
    fill: "#EB5166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.37f9fe15b610140353b7015a1b9a4a17.svg";
export { ForwardRef as ReactComponent };